import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface CampaignProps extends SvgIconProps {
  fill?: string;
}

export const Campaign: React.FC<CampaignProps> = ({ fill, ...props }) => {
  const theme = useTheme();
  const iconColor = fill || theme.palette.brandedTypography.textColor;

  return (
    <SvgIcon {...props} viewBox="0 0 18 19" fill="none">
      <path
        d="M9.23077 4.97855H1.84615C1.35652 4.97855 0.886947 5.1903 0.540726 5.5672C0.194505 5.94411 0 6.4553 0 6.98833V11.0079C0 11.5409 0.194505 12.0521 0.540726 12.429C0.886947 12.8059 1.35652 13.0176 1.84615 13.0176H2.76923V16.8589C2.76923 18.3035 4.79052 18.3772 4.79052 16.8589V13.0176H9.23077L13.8462 15.969V1.97015L9.23077 4.97855ZM12.5 13.7076L10.1538 11.6678H1.5V6.56838H10.1538L12.5 4.52861V13.7076ZM18 8.9981C18 10.7165 17.1138 12.274 15.6923 13.0176V4.97855C17.1046 5.73222 18 7.28979 18 8.9981Z"
        fill={iconColor}
      />
    </SvgIcon>
  );
};

export default Campaign;
